import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { memo } from "react";
import { EmptyState } from "../../../../../components/emptyState/emptyState";
import { useRankingClienteService } from "../../context/RankingClienteContext";
import RecursiveGroupedTableRow from "./RecursiveGroupedTableRow";

const ReportTable = ({ emptyMessage = "Sem dados", errorMessage, data }) => {
  const { columns } = useRankingClienteService();

  return (
    <>
      <TableContainer
        style={{
          maxHeight: "70vh",
          borderBottom: "1px solid #e3e3e3",
        }}
      >
        <Table aria-label="customized table" stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  align={column.align}
                  key={column.id}
                  style={{
                    backgroundColor: "#d6e5ff",
                    fontSize: "0.855rem",
                    minWidth: column.minWidth,
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {errorMessage ? (
              <TableRow>
                <TableCell align="center" colSpan={columns.length}>
                  {errorMessage}
                </TableCell>
              </TableRow>
            ) : data?.length ? (
              data?.map((cell, cellIndex) => {
                return (
                  <RecursiveGroupedTableRow
                    cell={cell}
                    key={cellIndex}
                    level={1}
                  />
                );
              })
            ) : (
              <TableRow>
                <TableCell align="center" colSpan={columns.length}>
                  <EmptyState message={emptyMessage} />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default memo(ReportTable);
